var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremiumStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9791 5.89672C10.9264 5.73473 10.7827 5.62004 10.6134 5.60472L8.30405 5.39506L7.39137 3.25831C7.32399 3.10132 7.17067 3 7.00001 3C6.82935 3 6.67597 3.10132 6.60901 3.25831L5.69634 5.39506L3.38661 5.60472C3.21729 5.62034 3.07392 5.73503 3.02094 5.89672C2.96827 6.05871 3.01691 6.23638 3.14497 6.34869L4.89066 7.87942L4.37594 10.1464C4.33828 10.3131 4.40298 10.4855 4.54129 10.5855C4.61563 10.6395 4.70298 10.6664 4.79062 10.6664C4.86594 10.6664 4.94132 10.6464 5.00864 10.6061L7.00001 9.41545L8.99101 10.6061C9.13707 10.6934 9.32073 10.6854 9.45873 10.5855C9.59704 10.4855 9.66174 10.3131 9.62408 10.1464L9.10936 7.87942L10.8551 6.34869C10.983 6.23638 11.0318 6.05907 10.9791 5.89672Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -6.90576,
    y1: 6.95288,
    x2: 7,
    y2: 20.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#775DFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumStar);
export default __webpack_public_path__ + "static/media/premiumStar.115c20cb.svg";
export { ForwardRef as ReactComponent };